













import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class TemplateFlowCancelButton extends Vue {
  @Prop({ default: true }) readonly visible!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
}
